'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils = require('../../utils.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var normaliseInput = require('ipfs-core-utils/pins/normalise-input');

var pinTypes = require('ipfs-repo/pin-types');

function createAddAll(_ref2) {
  var repo = _ref2.repo,
      codecs = _ref2.codecs;

  function addAll(_x) {
    return _addAll.apply(this, arguments);
  }

  function _addAll() {
    _addAll = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
      var options,
          pinAdd,
          lock,
          release,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

              pinAdd = /*#__PURE__*/function () {
                var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, path, recursive, metadata, _yield$_awaitAsyncGen, cid, _yield$_awaitAsyncGen2, reason;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _iteratorAbruptCompletion = false;
                          _didIteratorError = false;
                          _context.prev = 2;
                          _iterator = _asyncIterator(normaliseInput.normaliseInput(source));

                        case 4:
                          _context.next = 6;
                          return _awaitAsyncGenerator(_iterator.next());

                        case 6:
                          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                            _context.next = 30;
                            break;
                          }

                          _step$value = _step.value, path = _step$value.path, recursive = _step$value.recursive, metadata = _step$value.metadata;
                          _context.next = 10;
                          return _awaitAsyncGenerator(utils.resolvePath(repo, codecs, path));

                        case 10:
                          _yield$_awaitAsyncGen = _context.sent;
                          cid = _yield$_awaitAsyncGen.cid;
                          _context.next = 14;
                          return _awaitAsyncGenerator(repo.pins.isPinnedWithType(cid, [pinTypes.PinTypes.recursive, pinTypes.PinTypes.direct]));

                        case 14:
                          _yield$_awaitAsyncGen2 = _context.sent;
                          reason = _yield$_awaitAsyncGen2.reason;

                          if (!(reason === 'recursive' && !recursive)) {
                            _context.next = 18;
                            break;
                          }

                          throw new Error("".concat(cid, " already pinned recursively"));

                        case 18:
                          if (!recursive) {
                            _context.next = 23;
                            break;
                          }

                          _context.next = 21;
                          return _awaitAsyncGenerator(repo.pins.pinRecursively(cid, {
                            metadata: metadata
                          }));

                        case 21:
                          _context.next = 25;
                          break;

                        case 23:
                          _context.next = 25;
                          return _awaitAsyncGenerator(repo.pins.pinDirectly(cid, {
                            metadata: metadata
                          }));

                        case 25:
                          _context.next = 27;
                          return cid;

                        case 27:
                          _iteratorAbruptCompletion = false;
                          _context.next = 4;
                          break;

                        case 30:
                          _context.next = 36;
                          break;

                        case 32:
                          _context.prev = 32;
                          _context.t0 = _context["catch"](2);
                          _didIteratorError = true;
                          _iteratorError = _context.t0;

                        case 36:
                          _context.prev = 36;
                          _context.prev = 37;

                          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                            _context.next = 41;
                            break;
                          }

                          _context.next = 41;
                          return _awaitAsyncGenerator(_iterator.return());

                        case 41:
                          _context.prev = 41;

                          if (!_didIteratorError) {
                            _context.next = 44;
                            break;
                          }

                          throw _iteratorError;

                        case 44:
                          return _context.finish(41);

                        case 45:
                          return _context.finish(36);

                        case 46:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[2, 32, 36, 46], [37,, 41, 45]]);
                }));

                return function pinAdd() {
                  return _ref.apply(this, arguments);
                };
              }();

              lock = Boolean(options.lock);

              if (lock) {
                _context2.next = 6;
                break;
              }

              return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pinAdd()), _awaitAsyncGenerator), "t0", 5);

            case 5:
              return _context2.abrupt("return");

            case 6:
              _context2.next = 8;
              return _awaitAsyncGenerator(repo.gcLock.readLock());

            case 8:
              release = _context2.sent;
              _context2.prev = 9;
              return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pinAdd()), _awaitAsyncGenerator), "t1", 11);

            case 11:
              _context2.prev = 11;
              release();
              return _context2.finish(11);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[9,, 11, 14]]);
    }));
    return _addAll.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(addAll);
}

exports.createAddAll = createAddAll;